<template>
<div class='nginx-uploader'>
  <div class='el-button el-button--primary el-button--large'>
    {{label}}
    <input id="fileupload" class='fileupload' type="file" name="files[]" :accept="accept">
  </div>
</div>
</template>

<script>
import logger from '@/assets/scripts/logger'
import { lazyload } from '@/assets/scripts/lazy-load-module'
import { generateSessionID } from '@/assets/scripts/misc'

// according to jquery-file-upload:
// https://github.com/blueimp/jQuery-File-Upload/blob/master/js/jquery.fileupload.js#L314
const supportXHRUpload = !!(window.ProgressEvent && window.FileReader) || !!window.FormData

export default {
  data() {
    return {
      sessionID: null,
      retries: 0,
      uploadedBytes: 0
    }
  },
  props: {
    label: {
      type: String,
      default: '本地上传'
    },
    onUploadingLabel: {
      type: String,
      default: '上传中...'
    },
    url: String,
    accept: String,
    extensions: Array
  },
  computed: {
    uploadOptions() {
      let vm = this
      let file = {}
      return {
        url: supportXHRUpload ? `${process.env.API_ROOT}uploads` : `${process.env.API_ROOT}misc/fast_upload`,
        maxChunkSize: 1024 * 256,
        maxRetries: 2,
        retryTimeout: 1000,
        multipart: false,
        forceIframeTransport: !supportXHRUpload,
        dataType: supportXHRUpload ? '' : 'json',

        // hand-in sessionID if upload as iframe, the server need sessionID to store the file
        formData: function() {
          return [{
            name: 'sessionID',
            value: vm.sessionID
          }]
        },

        // Collect some basic information about the file.
        add(e, data) {
          logger.info('file added', data)
          file = data.files[0]

          // shallow file extension validation
          let extension = file.name.split('.').pop().toLowerCase()
          if (vm.extensions.indexOf(extension) < 0) {
            vm.$message({
              message: '文件名不包含指定格式',
              type: 'error'
            })
            return
          }
          // update filename and filesize
          vm.$emit('update:filename', file.name)
          vm.$emit('update:filesize', file.size || 0)

          // get sessionID
          vm.sessionID = generateSessionID(vm.$store.state.user.info.id, file)
          console.log('sessionID', vm.sessionID)

          // update ui
          vm.$emit('update:uploading', true)

          data.submit()
        },

        /*
         * Do something when the upload is done.
         */
        done: function(e, data) {
          let result = data.result
          if (result && typeof result === 'string') {
            vm.sessionID = result
          } else if (result && result.session_id) {
            vm.sessionID = result.session_id
          }
          logger.info('upload done, sessionID is ' + vm.sessionID)

          // 清理cookie存的Token
          generateSessionID(vm.$store.state.user.info.id, file, { clean: true })

          vm.$emit('complete', { session_id: vm.sessionID })
        },

        /*
         * This method is called whenever progress is reported back from nginx.
         */
        progress: function(e, data) {
          vm.$emit('update:progress', parseInt(data.loaded / data.total * 100, 10) || 0)
          logger.debug('progress', data.loaded, data.total)
        },

        /*
         * This method prepares the chunk that is about to be uploaded.
         */
        beforeSend: function(e, files, index, xhr, handler, callback) {
          // Set uploadedBytes on the context to ensure that if this upload was
          // resumed, it will continue from where it left off.
          vm.uploadedBytes = files.uploadedBytes
          //
          // Set the required headers for the nginx upload module
          e.setRequestHeader('Session-ID', vm.sessionID)
          e.setRequestHeader('X-Requested-With', 'XMLHttpRequest')

          let device = navigator.userAgent.toLowerCase()
          let ios = device.match(/(iphone|ipod|ipad)/)
          let chrome = device.match(/crios/)

          if (ios && !chrome) {
            e.setRequestHeader('Cache-Control', 'no-cache')
          }
        },

        /*
         * This method will be called whenever an upload (or a single chunk) fails
         * to complete. In this case, we're setting up an auto-resume feature to
         * attempt the upload again (respecting our retry and timeout settings).
         */
        fail: function(e, data) {
          logger.error(`nginx upload fail (${vm.retries}/${data.maxRetries}): ${JSON.stringify(data.response())}`)
          // If we can still attempt a retry
          if (vm.retries < data.maxRetries) {
            // Increment the retry count
            vm.retries += 1
            window.setTimeout(function() {
              // Reassign the uploadedBytes, then submit to start the upload again.
              data.uploadedBytes = vm.uploadedBytes
              data.data = null
              data.submit()
            }, vm.retries * data.retryTimeout)
          } else {
            // We've met our retry limit. Indicate that this upload has failed.
            // force file to be sent via simple-a
            vm.retries = 0
            logger.debug('totally failure after retry several times')
            vm.$message({
              message: '网络好像有点问题，重新上传试试吧~',
              type: 'error',
              duration: 5000
              // showClose: true,
            })
            vm.$emit('error', 'nginx')
          }
        }
      }
    }
  },
  methods: {
    init() {
      let vm = this
      lazyload('jquery').then($ => {
        lazyload('blueimp-file-upload').then(_ => {
          vm.$nextTick(_ => {
            $(vm.$el).find('input#fileupload').fileupload(vm.uploadOptions)
          })
        })
      })
    },
    destroy() {
      let vm = this
      lazyload('jquery').then($ => {
        let target = $(vm.$el).find('input#fileupload')
        if (target && target.fileupload) {
          target.fileupload('destroy')
        }
      })
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  }
}
</script>

<style lang="scss" scoped>
.nginx-uploader {
    .el-button {
        position: relative;
    }

    input.fileupload {
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// nginx_uploader.input.vue?cd43c25c